class Hotspot extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      hotspotImage: '[js-hotspot-image]',
      hotspot: '[js-hotspot]',
      hotspotButton: '[js-hotspot-button]',
      hotspotContent: '[js-hotspot-content]'
    }
  }

  connectedCallback() {
    this.hopspotImage = this.querySelector(this._selectors.hotspotImage);
    this.hotspots = this.querySelectorAll(this._selectors.hotspot);
    this.hotspotButtons = this.querySelectorAll(this._selectors.hotspotButton);

    this._setListeners();
    this._adjustHotspotContentPositions();
  }

  _setListeners() {
    this.hotspotButtons.forEach((btn) => {
      btn.addEventListener('click', this._toggleHotspot);
    });
    window.addEventListener('resize', this._adjustHotspotContentPositions);
  }

  _toggleHotspot = (evt) => {
    const currnetHotspot = evt.currentTarget.closest(this._selectors.hotspot);

    if (currnetHotspot.dataset.show == 'false') {
      this.hotspots.forEach((hotspot) => {
        hotspot.setAttribute('data-show', 'false');
      });
      currnetHotspot.setAttribute('data-show', 'true');
    } else {
      currnetHotspot.setAttribute('data-show', 'false');
    }
  }

  _adjustHotspotContentPositions = () => {
    const imageRect = this.hopspotImage.getBoundingClientRect();
    const imageWidth = imageRect.width;

    this.hotspots.forEach((hotspot) => {
      const hotspotContent = hotspot.querySelector(this._selectors.hotspotContent);
      const hotspotRect = hotspot.getBoundingClientRect();
      let moveX = 0;
      let moveY = 0;

      const spaceXR = imageRect.right - hotspotRect.left;
      const spaceXL = imageWidth - spaceXR + 32;
      if (spaceXR < 300) {
        if (spaceXL > 312) {
          moveX = 'calc(-100% + 32px)';
        } else {
          moveX = `-${300 - spaceXR + 12}px`;
        }
      }

      const hotspotHeigt = hotspotRect.height;
      const spaceYB = imageRect.bottom - hotspotRect.top;
      if (spaceYB < hotspotHeigt + 12) {
        moveY = 'calc(-100% - 48px)';
      }

      if (hotspotContent) hotspotContent.style.transform = `translate(${moveX}, ${moveY})`;
    });
  }
}

if (!customElements.get('hotspot')) customElements.define('hotspot', Hotspot)